import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LoginForm from 'components/LoginForm';
import NewPasswordForm from 'components/NewPasswordForm';
import VerificationForm from 'components/VerificationForm';
import { Attributions } from '@xbcb/static-text-components';
import attribution from 'assets/attribution.txt';
import styled from 'styled-components';

const StyledLogin = styled.section`
  height: calc(100vh - var(--space-6)); // 100% wasn't working for some reason

  .content-main {
    flex-flow: column wrap;
    align-content: center;
    height: 100%;
    background-color: white;
    minheight: 75vh;
    padding: 150px 25px 25px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .attributions {
      text-align: center;
    }
  }
`;

class Login extends Component {
  forms = {
    login: <LoginForm />,
    newPassword: <NewPasswordForm />,
    verification: <VerificationForm />,
  };
  componentDidMount() {
    this.props.mountLogin();
  }

  shouldComponentUpdate(nextProps) {
    const different = this.props.form !== nextProps.form;
    return different;
  }
  render() {
    const form = this.forms[this.props.form];
    return (
      <StyledLogin>
        <div className="content-main">
          {form}
          <Attributions attribution={attribution} />
        </div>
      </StyledLogin>
    );
  }
}

Login.propTypes = {
  form: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
};

export default Login;
